import {
  Activity,
  Archive,
  ArrowDownLeft,
  ArrowUpRight,
  AtSign,
  BarChart3,
  Bell,
  Book,
  BookOpen,
  Boxes,
  Braces,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  CreditCard,
  Database,
  DatabaseBackup,
  DollarSign,
  Download,
  Edit,
  ExternalLink,
  EyeOff,
  FileSpreadsheet,
  FileText,
  FileUp,
  Filter,
  Fingerprint,
  FolderArchive,
  GitBranch,
  Globe,
  Grid,
  HelpCircle,
  History,
  Inbox,
  Info,
  Key,
  KeyRound,
  Layers,
  Layout,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  Lock,
  type LucideIcon,
  Mail,
  MapPin,
  Menu,
  MessageSquare,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Network,
  Package,
  Palette,
  PenTool,
  Plus,
  Puzzle,
  Receipt,
  RefreshCw,
  ScanText,
  ScrollText,
  Search,
  Send,
  Settings,
  Share2,
  ShoppingBag,
  Shield,
  ShieldCheck,
  Shuffle,
  Sliders,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  TableProperties,
  Trash2,
  TrendingUp,
  Upload,
  User,
  UserCheck,
  Users,
  Video,
  Webhook,
  Workflow,
  Wrench,
  X,
  Zap,
} from 'lucide-react';

export const baseIcons: Record<string, LucideIcon> = {
  // Navigation & Shell
  'user-check': UserCheck,
  'building-2': Building2,
  network: Network,
  'key-round': KeyRound,
  'scroll-text': ScrollText,
  'sliders-horizontal': SlidersHorizontal,
  archive: Archive,
  'at-sign': AtSign,
  'bar-chart-3': BarChart3,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  clock: Clock,
  database: Database,
  mail: Mail,
  send: Send,
  star: Star,
  'shopping-bag': ShoppingBag,
  wrench: Wrench,
  book: Book,
  boxes: Boxes,
  briefcase: Briefcase,
  building: Building,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'file-text': FileText,
  grid: Grid,
  'help-circle': HelpCircle,
  inbox: Inbox,
  'message-square': MessageSquare,
  video: Video,
  smartphone: Smartphone,
  'share-2': Share2,
  layers: Layers,
  layout: Layout,
  'life-buoy': LifeBuoy,
  package: Package,
  receipt: Receipt,
  settings: Settings,
  shuffle: Shuffle,
  sliders: Sliders,
  'trending-up': TrendingUp,
  users: Users,
  user: User,

  // Settings & Controls
  activity: Activity,
  braces: Braces,
  'database-backup': DatabaseBackup,
  'eye-off': EyeOff,
  'file-spreadsheet': FileSpreadsheet,
  'file-up': FileUp,
  fingerprint: Fingerprint,
  'git-branch': GitBranch,
  globe: Globe,
  key: Key,
  'layout-dashboard': LayoutDashboard,
  lock: Lock,
  'map-pin': MapPin,
  palette: Palette,
  puzzle: Puzzle,
  shield: Shield,
  'shield-check': ShieldCheck,
  'table-properties': TableProperties,
  webhook: Webhook,
  workflow: Workflow,
  zap: Zap,
  'folder-archive': FolderArchive,
  'pen-tool': PenTool,
  'scan-text': ScanText,
  'book-open': BookOpen,
  bell: Bell,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  history: History,
  'layout-grid': LayoutGrid,
  menu: Menu,
  moon: Moon,
  search: Search,
  sparkles: Sparkles,
  sun: Sun,
  x: X,

  // Actions
  'arrow-down-left': ArrowDownLeft,
  'arrow-up-right': ArrowUpRight,
  check: Check,
  download: Download,
  edit: Edit,
  'external-link': ExternalLink,
  filter: Filter,
  info: Info,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  plus: Plus,
  'refresh-cw': RefreshCw,
  'trash-2': Trash2,
  upload: Upload,
};
